import { useMutation } from '@tanstack/react-query'
import { postConvertQuote } from 'services/WalletsService'

export const usePostConvertQuoteMutation = () => {
  return useMutation({ mutationFn: postConvertQuote })
}
